import { Canvas } from "@react-three/fiber";
import { useLoader, useFrame } from "@react-three/fiber";
import {
  Environment,
  OrbitControls,
  PerspectiveCamera,
} from "@react-three/drei";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { Suspense, useRef, useEffect } from "react";
import { AnimationMixer } from "three";

const cameraPostion = {
  cape: {
    primitive: [0, -1, 0],
    camera: [0, 0, 2],
  },
  artifact: {
    primitive: [0, -1.2, 0],
    camera: [0, 0, -3],
  },
  mount: {
    primitive: [0, -0.4, 0],
    camera: [-2, 2, -3],
  },
};

export default function CosmeticModel({ item }) {
  const Model = ({ path }) => {
    const gltf = useLoader(GLTFLoader, path);
    const mixer = useRef();

    useEffect(() => {
      if (gltf.animations && gltf.animations.length > 0) {
        mixer.current = new AnimationMixer(gltf.scene);
        gltf.animations.forEach((clip) =>
          mixer.current?.clipAction(clip).play()
        );
      }
    }, [gltf]);

    useFrame((state, delta) => {
      if (mixer.current) {
        mixer.current.update(delta);
      }
    });

    return (
      <primitive
        object={gltf.scene}
        scale={1}
        position={cameraPostion[item.type].primitive}
        rotation={item.type === "cape" ? [0, Math.PI, 0] : [0, 0, 0]}
      />
    );
  };

  return (
    <div className="cosmetic_model_container grey">
      <Canvas className="drop-shadow">
        <Suspense fallback={null}>
          <Model path={item.model} />
          <PerspectiveCamera
            makeDefault
            position={
              item.type === "cape"
                ? [0, 0, -2]
                : cameraPostion[item.type].camera
            }
          />
          <OrbitControls autoRotate={true} />
          <Environment
            background={false}
            files="https://app.zeqa.net/cosmetic/hdr.hdr"
          />
        </Suspense>
      </Canvas>
    </div>
  );
}
